// JWT 서명키 교체 시 사용자·디바이스 저장소 끝 숫자를 함께 올린다. 운영과 반드시 일치해야 한다.
export const USER_STORAGE_KEY = 'occHotelUserInfo2';
export const LEGACY_USER_STORAGE_KEYS = ['occHotelUserInfo'];
export const DEVICE_STORAGE_KEY = 'occHotelDeviceInfo2';
